import MUIDataTable, { MUIDataTableOptions, MUIDataTableProps } from "mui-datatables";

export type {
  MUIDataTableState as UIDataTableState,
  MUIDataTableColumnDef as UIDataTableColumnDef,
  MUIDataTableOptions as UIDataTableOptions,
  MUIDataTableColumnOptions as UIDataTableColumnOptions,
  CustomHeadLabelRenderOptions as UICustomHeadLabelRenderOptions,
} from "mui-datatables";

// Shared defaults so every table in the app presents the same empty state;
// screens can still override via options.textLabels.
const UIDataTable = ({ options, ...props }: MUIDataTableProps) => {
  const mergedOptions: MUIDataTableOptions = {
    ...options,
    textLabels: {
      ...options?.textLabels,
      body: {
        noMatch: "No records to display",
        ...options?.textLabels?.body,
      },
    },
  };
  return <MUIDataTable {...props} options={mergedOptions} />;
};

export default UIDataTable;
